import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { HiOutlineAcademicCap } from "react-icons/hi";
import { FiDownload } from "react-icons/fi";
import { IoMdLock } from "react-icons/io";
import dayjs from "dayjs";

// MUI
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

// Contexts
import { useMasteryMap } from "../../context";

// Components
import Progress from "../../../../components/progress";
import SubUnitRow from "../SubUnitRow";
import { ALLOWED_MIME_TYPES } from "../../../../components/AttachMaterials";

// Styles
import styles from "./unitCard.module.scss";

const UnitCard = ({ unit }) => {
  const { t } = useTranslation();
  const { subUnitsMap } = useMasteryMap();

  // Ref
  const fileInputRef = useRef(null);

  // Handlers
  const handleFileChange = (e) => {
    // TODO: Keith/Dmytro/Alex -> Implement file upload to a unit
  };

  const handleUploadMaterial = () => {
    fileInputRef.current.click();
  };

  const handlePractice = () => {
  };

  if (!unit) return null;
  const { title, description } = unit;
  const progress = 50;
  const isLocked = dayjs().isBefore(unit.start_date);

  // Renders
  const renderSubunits = () => {
    const subunits = subUnitsMap[unit.id] || [];

    if (!subunits || subunits.length === 0) return null;
    return (
      <div className={`${styles.cardSubunits}`}>
        {subunits.map((subunit, index) => (
          <SubUnitRow
            key={subunit.id}
            subunit={subunit}
            index={index}
            isLast={index === subunits.length - 1}
            isLocked={isLocked}
          />
        ))}
      </div>
    );
  };


  return (
    <div className={`${styles.card} p-2 rounded-lg`}>
      <div className="flex flex-col border-b-2 border-gray-200 pb-2">
        <div className="flex flex-row items-center gap-4">
          <Typography variant="h6" color="text.primary">{title}</Typography>

          {isLocked && (
            <div className="flex flex-row items-center gap-2 text-sm text-gray-500">
              <IoMdLock className="text-xl" />

              <span>{dayjs(unit.start_date).format('MMM D')}</span>
            </div>
          )}
        </div>
        <Typography variant="body2" color="text.secondary">{unit.description}</Typography>

        <Progress progress={progress} classes={{ progressContainer: isLocked ? 'opacity-50' : '' }} />
      </div>

      {renderSubunits()}

      <div className={`${styles.cardActions}`}>
        <Button
          onClick={handleUploadMaterial}
          disabled={isLocked}
          variant="outlined"
          color="primary"
          sx={{ flex: 1 }}
          startIcon={<FiDownload className="text-xl" />}
        >
          {t('masteryMap.actions.upload_material')}
        </Button>

        <Button
          onClick={handlePractice}
          disabled={isLocked}
          variant="contained"
          color="primary"
          sx={{ flex: 1 }}
          startIcon={<HiOutlineAcademicCap className="text-xl" />}
        >
          {t('masteryMap.actions.practice')}
        </Button>
      </div>

      <input
        type="file"
        hidden
        ref={fileInputRef}
        accept={ALLOWED_MIME_TYPES.join(',')}
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
    </div>
  );
};

export default UnitCard;
